import PageRouteInterface from "@app/Interface/PageRouteInterface";

export default class PageRouteModel implements PageRouteInterface {
    id: number;
    title: string;
    path: string;
    template: string;
    chartType: string;
    reportType: string;
    contactType: string;

    constructor(data?: PageRouteInterface) {

        this.id = Number(data?.id) ?? 0;
        this.title = data?.title ?? "";
        this.path = data?.path ?? "";
        this.template = data?.template ?? "";
        this.chartType = data?.chartType ?? "";
        this.reportType = data?.reportType ?? "";
        this.contactType = data?.contactType ?? "";

    }

}